// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-header {\n  display: block;\n}\n.normal-close-btn{\n  width: 30px;\n  cursor: pointer;\n  float: right;\n  position: relative;\n  right: 0px;\n}\n.normal-modal-title{\n  color: #366CFF;\n  text-align: center;\n  border: 1px solid #366CFF;\n  border-radius: 15px;\n  padding: 10px;\n  font-size: 28px;\n  font-weight: 600;\n  letter-spacing: 4px;\n  margin-top: -10px;\n}\n.normal-submit-btn{\n  margin: 0 auto;\n  border-radius: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
